module.exports = "/_next/static/images/98afe76c24e723caa91994107c41d6d7-group-man-building@3x.jpg";